import { Observer } from "mobx-react-lite";
import React from "react";
import { useControllers } from "../../hooks/controller.hooks";
import Dialog from "./Dialog";
export var DialogStack = function () {
    var DIALOG = useControllers().UI.DIALOG;
    return React.createElement(Observer, { children: function () { return (React.createElement(React.Fragment, null, DIALOG.lastDialog && React.createElement(Dialog, { dialog: DIALOG.lastDialog, key: DIALOG.lastDialog.id }))); } });
};
